<div class="modal-body">
  <h5> Vous n'avez actuellement aucun abonnement </h5>
  <hr>
  <p>Pour accéder à la mission, vous devez souscrire à un abonnement. <a role="button" class="btn btn-style" (click)="goSubscription()" >S'abonner</a></p>
  <hr>
  
</div>